import { render, staticRenderFns } from "./SubscribeBlock.vue?vue&type=template&id=678763c1&scoped=true&"
import script from "./SubscribeBlock.vue?vue&type=script&lang=js&"
export * from "./SubscribeBlock.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeBlock.vue?vue&type=style&index=0&id=678763c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678763c1",
  null
  
)

export default component.exports